export class HtmlUtils {
  static countVisibleCharacters(html: string): number {
    const temp = document.createElement('div');
    temp.innerHTML = html;

    // Remove script and style tags completely
    temp.querySelectorAll('script, style').forEach(el => el.remove());

    // Get only the text content
    const text = temp.textContent || '';
    return text.trim().length;
  }
}
